import { Guid } from '@ebeihilfe/core';

export class AntragUpdateDto {
  public concurrency: Date;
  public antragId: Guid;
  public encryptedMetadata: string;

  constructor(antragId: Guid, concurrency: Date, encryptedMetadata: string) {
    this.antragId = antragId;
    this.concurrency = concurrency;
    this.encryptedMetadata = encryptedMetadata;
  }
}
